// Composant Grille des Motifs d'Acceptation
import React from 'react';
import styled from 'styled-components';
import { theme } from '@theme';

export interface AcceptanceReason {
  title: string;
  description: string;
}

interface AcceptanceReasonGridProps {
  reasons: AcceptanceReason[];
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: ${theme.spacing.lg};
  margin-top: ${theme.spacing.lg};
`;

const ReasonBox = styled.div`
  padding: ${theme.spacing.lg};
  background: white;
  border: 2px solid ${theme.colors.success}40;
  border-radius: ${theme.borderRadius.lg};
  text-align: center;
  transition: all ${theme.transitions.fast};

  &:hover {
    border-color: ${theme.colors.success};
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.md};
  }

  @media print {
    box-shadow: none;
    page-break-inside: avoid;
  }
`;

const ReasonTitle = styled.h4`
  font-size: ${theme.typography.sizes.base};
  font-weight: ${theme.typography.weights.semibold};
  color: ${theme.colors.text};
  margin: 0 0 ${theme.spacing.xs} 0;
`;

const ReasonDescription = styled.p`
  font-size: ${theme.typography.sizes.sm};
  color: ${theme.colors.text}70;
  margin: 0;
  line-height: 1.5;
`;

export const AcceptanceReasonGrid: React.FC<AcceptanceReasonGridProps> = React.memo(({ reasons }) => {
  return (
    <Grid>
      {reasons.map((reason, index) => (
        <ReasonBox key={index}>
          <ReasonTitle>{reason.title}</ReasonTitle>
          <ReasonDescription>{reason.description}</ReasonDescription>
        </ReasonBox>
      ))}
    </Grid>
  );
});
